import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

export const accessibleChartTitleSx: SxProps<Theme> = {
  fontWeight: 500,
  color: 'text.primary',
  lineHeight: 1.5,
  letterSpacing: '0.12em',
  wordSpacing: '0.16em',
  mb: '2em',
  width: '100%',
  maxWidth: '100%',
  textAlign: 'start',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
};

/** Let chart cards grow when titles reflow under WCAG 1.4.12 text spacing. */
export const dashboardChartCardSx: SxProps<Theme> = {
  height: 'auto',
  maxHeight: 'none',
  overflow: 'visible',
};

export const chartCanvasFocusSx: SxProps<Theme> = {
  '& canvas': {
    outline: 'none',
    '&:focus-visible': {
      outline: '2px solid #153760',
      outlineOffset: '2px',
    },
  },
};

export function buildDoughnutChartAriaLabel(
  title: string,
  segments: Array<{ label: string; value: number }>,
  totalLabel = 'Total applications'
): string {
  const total = segments.reduce((sum, segment) => sum + segment.value, 0);
  const segmentDescriptions = segments
    .map((segment) => `${segment.label}: ${segment.value}`)
    .join(', ');

  return `${title}. Doughnut chart showing ${segmentDescriptions}. ${totalLabel}: ${total}.`;
}

export function buildStackedBarChartAriaLabel(
  title: string,
  months: string[],
  datasets: Array<{ label: string; data: number[] }>
): string {
  const monthDescriptions = months
    .map((month, index) => {
      const values = datasets
        .map((dataset) => `${dataset.label}: ${dataset.data[index] ?? 0}`)
        .join(', ');

      return `${month}: ${values}`;
    })
    .join('. ');

  return `${title}. Bar chart showing onboarding counts by month. ${monthDescriptions}.`;
}

export function buildCommitmentContributionChartAriaLabel(
  year: string,
  months: string[],
  commitmentValues: number[],
  contributionValues: number[]
): string {
  const monthDescriptions = months
    .map((month, index) => {
      return `${month}: Total committed value ${
        commitmentValues[index] ?? 0
      } crore, total contribution value ${contributionValues[index] ?? 0} crore`;
    })
    .join('. ');

  return `Month-wise commitment and contribution chart for year ${year}. ${monthDescriptions}. Graphical data is shown only for completed applications.`;
}
